import React, { useMemo } from "react";
import { Card, Row, Col, Input, Select, Typography, Space, Tag } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { COLORS } from "../types/types";

const { Text } = Typography;

interface SearchFiltersProps {
  searchText: string;
  onSearchChange: (value: string) => void;
  selectedCountry: string | undefined;
  onCountryChange: (value: string | undefined) => void;
  cityStats: Record<string, number>;
}

const SearchFilters: React.FC<SearchFiltersProps> = ({
  searchText,
  onSearchChange,
  selectedCountry,
  onCountryChange,
  cityStats,
}) => {
  const countryOptions = useMemo(() => {
    return Object.entries(cityStats)
      .map(([city, count]) => ({
        label: (
          <Space style={{ width: "100%", justifyContent: "space-between" }}>
            <span>{city}</span>
            <Tag color="blue">{count}</Tag>
          </Space>
        ),
        value: city,
      }))
      .sort((a, b) => a.value.localeCompare(b.value));
  }, [cityStats]);

  return (
    <Card
      variant="borderless"
      styles={{ body: { padding: 0 } }}
      style={{ marginBottom: 24, backgroundColor: COLORS.light, borderRadius: 8 }}
    >
      <div style={{ padding: 24 }}>
        <Row gutter={[24, 16]}>
          <Col xs={24} md={12}>
            <Text style={{ color: COLORS.textLight }}>Recherche</Text>
            <Input
              placeholder="Nom, prénom, entreprise, ville..."
              prefix={<SearchOutlined />}
              value={searchText}
              onChange={(e) => onSearchChange(e.target.value)}
              allowClear
            />
          </Col>
          <Col xs={24} md={12}>
            <Text style={{ color: COLORS.textLight }}>Filtre par ville</Text>
            <Select
              style={{ width: "100%" }}
              placeholder="Toutes les villes"
              value={selectedCountry}
              onChange={onCountryChange}
              allowClear
              showSearch
              optionFilterProp="children"
            >
              {countryOptions.map(option => (
                <Select.Option key={option.value} value={option.value}>
                  {option.label}
                </Select.Option>
              ))}
            </Select>
          </Col>
        </Row>
      </div>
    </Card>
  );
};

export default SearchFilters;